import PropTypes from 'prop-types';
import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';

// O tema capitaliza cada palavra do botao. O protótipo escreve em frase.
const BOTAO_EM_FRASE = { textTransform: 'none' };

// Conteudo do destaque da historia CBK-528 (secao 5, RF-02). A moldura, o fundo
// escuro e a posicao junto ao seletor ficam no BusinessMigrationNotice.
export default function BusinessMigrationBanner({ onDismiss, isDismissing }) {
  return (
    <Stack>
      <Typography id="business-migration-title" variant="h6" gutterBottom>
        Sua conta agora é um Negócio
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Seus produtos, vendas, gestão e relatórios agora ficam organizados em um Negócio. Por aqui,
        você pode alternar entre negócios e criar novos quando precisar.
      </Typography>

      <Stack direction="row" justifyContent="flex-end" mt={3}>
        <LoadingButton
          variant="contained"
          loading={isDismissing}
          onClick={onDismiss}
          sx={BOTAO_EM_FRASE}
        >
          Entendi
        </LoadingButton>
      </Stack>
    </Stack>
  );
}

BusinessMigrationBanner.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  isDismissing: PropTypes.bool,
};
